import React, { memo, useRef, useMemo } from 'react';
import { isEqual } from 'lodash';
import { WindowScroller } from 'react-virtualized';
import { SortableContainer } from 'react-sortable-hoc';
import { useDispatch } from 'react-redux';
import VirtualLists from 'react-tiny-virtual-list';
import PropTypes from 'prop-types';

import SortableElement from '../SortableElement';

import { servicesCheckedSet } from '../../../../../../../../redux/actions/services';
import { getHeightRow } from '../../../../../helpers/getters';
import useShiftSelected from '../../../../../../../../utils/hooks/useShiftSelected';

const VirtualList = ({
  list,
  search,
  searchOption,
  serviceDispatch,
  config,
  massActions,
  scrollToCategoryId,
  scrollToServiceId,
  servicesChecked,
}) => {
  const listRef = useRef();

  const dispatch = useDispatch();

  const allServicesIds = useMemo(() => list.filter((item) => item.collection === 'service').map((item) => item.id), [list]);

  const scrollToIndex = () => {
    if (scrollToCategoryId || scrollToServiceId) {
      const findIndex = list.findIndex((item) => {
        if (item.collection === 'category' && scrollToCategoryId) {
          if (item.id === scrollToCategoryId) {
            return true;
          }
        }
        if (item.collection === 'service' && scrollToServiceId) {
          if (item.id === scrollToServiceId) {
            return true;
          }
        }
        return false;
      });
      if (findIndex !== -1) {
        return findIndex;
      }
    }
    return null;
  };

  const onChange = useShiftSelected(allServicesIds, servicesChecked)

  const onServiceCheck = (event, id) => {
    const nextValue = onChange(event, id);
    dispatch(servicesCheckedSet(nextValue));
  };

  const heightOffset = config.deleted_services ? 185 : 190;

  return (
    <>
      <WindowScroller>
        {({ height }) => (
          <VirtualLists
            ref={listRef}
            width="100%"
            className="service-table__container"
            height={height - heightOffset}
            itemCount={list.length}
            scrollDirection="vertical"
            scrollToAlignment="center"
            scrollToIndex={scrollToIndex()}
            itemSize={(index) => getHeightRow(list[index])}
            renderItem={({ index, style }) => (
              <SortableElement
                style={style}
                list={list}
                collection={list[index].collectionId}
                disabled={list[index].id === 0}
                key={index}
                config={config}
                massActions={massActions}
                serviceDispatch={serviceDispatch}
                index={index}
                search={search}
                searchOption={searchOption}
                onChangeCheckbox={onServiceCheck}
                row={list[index]}
              />
            )}
          />
        )}
      </WindowScroller>
    </>
  );
};

VirtualList.propTypes = {
  list: PropTypes.array,
  search: PropTypes.string,
  searchOption: PropTypes.string,
  serviceDispatch: PropTypes.func,
  config: PropTypes.object,
  massActions: PropTypes.array,
  scrollToCategoryId: PropTypes.number,
  scrollToServiceId: PropTypes.number,
  servicesChecked: PropTypes.array,
};

const VirtualSortableContainer = SortableContainer(VirtualList);

const arePropsEqual = (prevProps, nextProps) => {
  if (nextProps.isLoadingTable) {
    return true;
  }
  return isEqual([prevProps.list, prevProps.searchOption, prevProps.search], [nextProps.list, nextProps.searchOption, nextProps.search]);
};
export default memo(VirtualSortableContainer, arePropsEqual);
